// localStorageMiddleware.ts
import { AppState } from '@prometheus/types';
import type { Middleware } from '@reduxjs/toolkit';

// Helpers
function loadState(hash: string) {
  try {
    const serializedState = localStorage.getItem(hash + '_persistedState');
    return serializedState ? JSON.parse(serializedState) : undefined;
  } catch {
    return undefined;
  }
}

function saveState(hash: string, state: unknown) {
  try {
    localStorage.setItem(hash + '_persistedState', JSON.stringify(state));
    console.log('[localStorage] ✅ Saved state to localStorage:', state);
  } catch (err) {
    console.error('[localStorage] ❌ Failed to save state:', err);
  }
}

export const localStorageMiddleware: Middleware = store => next => action => {
  const result = next(action);

  //   console.log(action);
  const actionsToPersist = [
    'ADD_COMPARE_ITEM_SUCCESS',
    'REMOVE_COMPARE_ITEM_SUCCESS',
  ];

  if (actionsToPersist.includes(action.type)) {
    const state: AppState = store.getState();
    // console.log(state);
    console.log('[localStorage] Preparing to save slice:', {
      compare: state.compare,
    });
    if (typeof window === 'undefined') {
      console.warn(
        '[localStorage] ⚠️ Skipped — running in non-browser environment.'
      );
    } else {
      const uuid = `${state.user.data.id}${state.user.data.activeTenant}`;
      saveState(uuid, {
        compare: {
          ids: {
            conceptSets:
              state.compare.ids.conceptSets?.map(id =>
                id.uuid ? id : { ...id, uuid }
              ) ?? [],
          },
          data: {},
          counts: {},
        },
      });
    }
  }

  return result;
};

// Helper for preloaded state
export const getPreloadedState = loadState;
